<template>
	<div>
		<input type="file" :accept="accept" id="file" ref="myFiles" @change="previewFiles" multiple>
		<p style="margin-top:0px;margin-bottom:20px" class="text-info">Pressione o Ctrl para adicionar mais de um item.</p>
	</div>
</template>

<script>
export default {

	props:{
		accept: {
			type: String,
			required: true
		}
	},

	data (){
		return {
			files: []
		}
	},

	methods: {
		previewFiles() {

			this.files = []

			for (var i = 0; i < this.$refs.myFiles.files.length; i++) {

				this.getBase64(this.$refs.myFiles.files[i], i).then(returno => {
										this.files.push({
											base64: returno.base,
											nomeArquivo: returno.file.name
										});

										if(returno.index == this.$refs.myFiles.files.length - 1){
											this.carregouArquivo(this.files)
											this.$refs.myFiles.value = '';
										}
									});
			}
		},

		carregouArquivo(item){
			this.$emit('dados-anexo', item)
		},

		getBase64(file, index) {

			return new Promise((resolve, reject) => {
				var reader = new FileReader();
				reader.readAsDataURL(file);

				reader.onload = () => {
					resolve({base: reader.result, file: file, index: index});
				};
				reader.onerror = (error) => {
					reject(error)
					console.log("Error: ", error);
				};

			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/upload-file/main.vue